import React, { useEffect, useState } from 'react';
import { get } from '../core/http';
import { API } from '../core/constants';

// Deliberately its own small component rather than reusing MultiSelect — that one
// hardcodes the TAGS constant internally regardless of its `options` prop, so reusing
// it here would either silently show the wrong list or require touching a component
// other forms already depend on. This stays scoped to picking entities for an event.
const EntitySelect = ({ selectedIds = [], onChange }) => {
    const [entities, setEntities] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        get(`${API}/entities`)
            .then((result) => setEntities(result.body || []))
            .catch((err) => console.log(err));
    }, []);

    const toggle = (id) => {
        if (selectedIds.includes(id)) {
            onChange(selectedIds.filter((existing) => existing !== id));
        } else {
            onChange([...selectedIds, id]);
        }
    };

    const selectedEntities = entities.filter((e) => selectedIds.includes(e.id));
    const filtered = entities.filter((e) => e.name.toLowerCase().includes(search.toLowerCase()));

    return (
        <div>
            {selectedEntities.length > 0 && (
                <div className="flex flex-wrap gap-1 mb-1.5">
                    {selectedEntities.map((entity) => (
                        <span
                            key={entity.id}
                            className="badge badge-sm badge-accent gap-1"
                        >
                            {entity.name}
                            <button type="button" onClick={() => toggle(entity.id)} className="font-bold leading-none">
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
            )}

            <input
                className="input input-bordered input-sm w-full mb-1.5"
                placeholder="Search entities..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <div className="max-h-40 overflow-y-auto border border-base-300 rounded-md">
                {filtered.length === 0 ? (
                    <p className="p-2 text-sm text-base-content/50">No entities found</p>
                ) : (
                    filtered.map((entity) => (
                        <label key={entity.id} className="flex items-center gap-2 px-2 py-1.5 text-sm hover:bg-base-200 cursor-pointer">
                            <input
                                type="checkbox"
                                className="checkbox checkbox-xs"
                                checked={selectedIds.includes(entity.id)}
                                onChange={() => toggle(entity.id)}
                            />
                            <span>{entity.name}</span>
                        </label>
                    ))
                )}
            </div>
        </div>
    );
};

export default EntitySelect;
